module.exports = __webpack_public_path__ + "img/arrow.b39f23b1.svg";